"use client"

import { ResponsiveHeader } from "@/components/responsive-header"

export function ConsultHeader() {
  return <ResponsiveHeader />
}
